import React from 'react';

import { useCurrentUserPermissions, useCurrentUserStaff } from 'src/hooks/user';

import { usePeoPayrollProviderById } from './usePeoPayrollProviderById';

export const useCurrentUserPeoPayrollProvider = () => {
  const { peoPayrollProviderStaff } = useCurrentUserStaff();
  const { isPeoPayrollProviderUser } = useCurrentUserPermissions();

  const peoPayrollProviderId = React.useMemo(() => {
    if (!isPeoPayrollProviderUser) return null;
    return peoPayrollProviderStaff?.peoPayrollProvider.id;
  }, [isPeoPayrollProviderUser, peoPayrollProviderStaff?.peoPayrollProvider.id]);

  return usePeoPayrollProviderById(peoPayrollProviderId);
};
